export default {
  DESIGN_SETTINGS: 'design-settings',
  TEXT_EDITING: 'text-editing',
};
